// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__NcVGP","wrapper-nopadding":"wrapper-nopadding__1YeNs","loading":"loading__1H2Oz","error":"error__1mhM3","table-loading":"table-loading__SIoAt","empty-val":"empty-val__2uLao","panelheader-tools":"panelheader-tools__RR9YZ","propsPanels":"propsPanels__3vRBF","new":"new__3YjCA","marginLm":"marginLm__Q4XsJ","marginRm":"marginRm__3r-UN","fullWidth":"fullWidth__3ikoz","fullHeight":"fullHeight__3F7l8","noData":"noData__iAcoH"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Application/coms/ApplicationDetail/coms/APIView/styles.scss
// module id = 2175
// module chunks = 1